import app from 'flarum/forum/app';
import { extend } from 'flarum/common/extend';
import HeaderPrimary from 'flarum/forum/components/HeaderPrimary';

app.initializers.add('kemze-logolivetext', () => {
    let logoText = '';
    let fetched = false;

    extend(HeaderPrimary.prototype, 'oncreate', function () {
        if (fetched) return;
        fetched = true;

        app.request({
            method: 'GET',
            url: app.forum.attribute('apiUrl') + '/logotext',
        }).then((result) => {
            logoText = result.text || '';
            m.redraw();
        }).catch(() => {});
    });

    extend(HeaderPrimary.prototype, 'items', function (items) {
        if (!logoText) return;
        items.add(
            'kemze-logolivetext',
            <span className="kemze-logolivetext-text">{logoText}</span>,
            -100
        );
    });
});
